import { useFund } from '../context/FundContext';

// The "Fund + Date" filter strip that appears at the top of most Seamless screens.
export default function FundDateBar() {
  const { funds, fund, setFund, date, setDate } = useFund();
  return (
    <div className="filterbar">
      <div className="field">
        <label>Fund</label>
        <select value={fund} onChange={(e) => setFund(e.target.value)}>
          {funds.map((f) => (
            <option key={f.id} value={f.name}>
              {f.alias || f.name}
            </option>
          ))}
        </select>
      </div>
      <div className="field">
        <label>Date</label>
        <input type="date" value={date} onChange={(e) => setDate(e.target.value)} />
      </div>
    </div>
  );
}
